import styled from 'styled-components';
import { Text } from '../../../../../shared/components';

export const BackButtonStyled = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: ${({ marginBottom }) => marginBottom};
`
export const BackTextStyled = styled(Text)`
  font-size: 17px;
  color: var(--orangeColorMain);
`